export default "__VITE_ASSET__5e9a0196__"